import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, vModelCheckbox as _vModelCheckbox, withDirectives as _withDirectives, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "event_content" }
const _hoisted_2 = { class: "content_title" }
const _hoisted_3 = { class: "checkbox_options" }
const _hoisted_4 = ["for"]
const _hoisted_5 = ["id", "value"]
const _hoisted_6 = ["innerHTML"]
const _hoisted_7 = { class: "btns" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ModalDefault = _resolveComponent("ModalDefault")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _cache[5] || (_cache[5] = _createElementVNode("div", { class: "event_title" }, [
      _createElementVNode("p", null, "공감되는 메시지에 표시해주세요 (중복가능)")
    ], -1)),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("p", _hoisted_2, "\"" + _toDisplayString($setup.state.currentOption.title) + "\"", 1),
      _createElementVNode("ul", _hoisted_3, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.state.currentOption.contentList, (option, idx) => {
          return (_openBlock(), _createElementBlock("li", null, [
            _createElementVNode("label", {
              for: `option${idx}`,
              class: "custom_check"
            }, [
              _withDirectives(_createElementVNode("input", {
                type: "checkbox",
                id: `option${idx}`,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (($setup.state.value) = $event)),
                value: option.idx
              }, null, 8, _hoisted_5), [
                [_vModelCheckbox, $setup.state.value]
              ]),
              _cache[4] || (_cache[4] = _createElementVNode("span", null, null, -1)),
              _createElementVNode("div", null, [
                _createElementVNode("p", null, [
                  _createTextVNode(_toDisplayString(option.text) + " ", 1),
                  _createElementVNode("span", null, "-" + _toDisplayString(option.write) + "-", 1)
                ])
              ])
            ], 8, _hoisted_4)
          ]))
        }), 256))
      ]),
      _createElementVNode("p", {
        class: "content_comment",
        innerHTML: $setup.state.currentOption.comment
      }, null, 8, _hoisted_6),
      _createElementVNode("div", _hoisted_7, [
        ($setup.props.step > 1)
          ? (_openBlock(), _createElementBlock("button", {
              key: 0,
              id: "prev",
              onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => ($setup.prev && $setup.prev(...args)))
            }, "이전"))
          : _createCommentVNode("", true),
        _createElementVNode("button", {
          id: "next",
          onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => ($setup.next && $setup.next(...args)))
        }, "다음")
      ])
    ]),
    ($setup.modal.isShow)
      ? (_openBlock(), _createBlock(_component_ModalDefault, {
          key: 0,
          type: $setup.modal.type,
          title: $setup.modal.title,
          content: $setup.modal.content,
          onClose: _cache[3] || (_cache[3] = ($event: any) => ($setup.modal.isShow = false))
        }, null, 8, ["type", "title", "content"]))
      : _createCommentVNode("", true)
  ], 64))
}